import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { RiQuestionLine } from "react-icons/ri";
import { BoxStyled } from "./../styledComponents/component";


const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  gridIcon: {
    width: "45px",
    height: "45px",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    marginTop: 10,
  },
  colIcon: {
    fontSize: '3rem'
  },
  btnStart: {
    color: 'white',
    padding: '10px 20px',
    margin: '10px 0px 5px 0px',
    borderRadius: 5,
    cursor: 'pointer'
  },
  gridBtns: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width:460px)': {
      flexDirection: 'column-reverse'
    },
  },
  desc: {
    padding: '10px 5px',
    width: '90%',
    minWidth: '50%',
    textAlign: 'center',

  }
}))

const StartQuestion = ({ setflagStart, handlePrevStep, loading, data , setIndexChild }) => {

  let classes = useStyles()

  return (
    <>
      <BoxStyled minHeight={200}>
        <div className={classes['root']}>
          <div className={`${classes['gridIcon']} bg-primaryLightColor`} >
            <div className={`${classes['colIcon']} text-primaryColor`} >
              <RiQuestionLine />
            </div>
          </div>
          <p className={classes['desc']} >
            این پرسشنامه، جهت سنجش اطلاعات شما سرمایه‌گذار عزیز، تهیه شده است. با پاسخ‌دهی دقیق به آن، تیم پویان می‌تواند خدمات بهتری متناسب با سلیقه شما، ارائه کند.
          </p>
          <div className={classes['gridBtns']}>
            <Button
              className={"footer-button-back m-2"}
              onClick={handlePrevStep}
            >
              بازگشت
            </Button>

            <Button
              className={"footer-button-next-active m-2"}
              onClick={() => !loading
                ? data?.length == 0
                  ? alert('آزمونی در حال انجام نمی باشد')
                  : setflagStart(true)

                : null}
            >
              {
                (loading)
                  ? <span>در حال بارگذاری...</span>
                  : <span>شروع کنید </span>

              }
            </Button>
          </div>
        </div>
      </BoxStyled>
    </>
  );
};

export default StartQuestion;
